import { queryOptions } from '@tanstack/react-query';

import { getInventoriesQuery, getInventoryQuery } from './shared';

export const getInventoryQueryOptions = (id: string) => queryOptions(getInventoryQuery(id));
export const getInventoriesQueryOptions = () => queryOptions(getInventoriesQuery());
